import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonImg, IonText } from '@ionic/react';
import { FC } from 'react';
import { translation } from '../models/translation';
import { useHistory } from 'react-router';
import { userLink } from '../utlities/userLink';
import { User } from '../models/data';

interface CampaingCardProps {
    title: string,
    id: string,
    imageUrl?: string,
    description: string,
    navigate: any,
    user:User|any
}

const CampaignCard: FC<CampaingCardProps> = ({ title, id, imageUrl, description, navigate,user }) => {
    const siteText = translation();
    const lan = siteText.lan.replace("/", "");
    const history = useHistory();

    const startDonating = () => {
        history.push(`/${lan}/${userLink(user)}direct_to_fundraiser?id=${id}`)
    
      }
    return (
        <IonCol sizeXs='12' sizeSm='6' sizeMd='4'>
            <IonCard className='fundraiserCard' mode='md'>
                <IonCardHeader>
                    <div className='img16by9-container'>
                        <IonImg className='img16by9' src={imageUrl ? imageUrl : `${import.meta.env.BASE_URL}images/placeholder_image.jpg`}></IonImg>
                    </div>
                    <IonCardTitle className='ion-text-uppercase'><span dangerouslySetInnerHTML={{ __html: title }}></span></IonCardTitle>
                </IonCardHeader>
                <IonCardContent className=''>
                    <p dangerouslySetInnerHTML={{ __html: `${description.substring(0, 320)}...` }}></p>
                    <IonButton color={"medium"} className='ion-margin-bottom' size='small' fill='outline' onClick={e => navigate(id)}>{siteText.detailsBtnTxt}</IonButton>
                    <IonButton className='ion-margin-bottom' size='small' onClick={startDonating}>
                        <IonText color={"light"}>
                            {siteText.charityDetailPrimary}
                        </IonText>
                    </IonButton>
                </IonCardContent>
            </IonCard>
        </IonCol>

    )
}

export default CampaignCard;